const es = {
  welcome_to_agami: 'Bienvenido a Agami Route',
  login: 'INICIAR SESIÓN',
  send_email: 'ENVIAR CORREO ELECTRÓNICO',
  login_with_password: 'Iniciar sesión con contraseña',
  login_with_email: 'Iniciar sesión solo con correo electrónico',
  lang: 'Español',
  select_lang: 'Selecciona tu idioma',
  day: 'Día',
  night: 'Noche',
  confirm: 'Confirmar',
  continue: 'Continuar',
  cancel: 'Cancelar',
  refresh: 'Recargar',
  yes_continue: 'Sí, continuar',
  start: 'Comenzar',
  back: 'Atrás',
  wait: 'Por favor espera...',
  headset: 'Por favor, usa los auriculares proporcionados para una mejor experiencia',
  raise_volume: 'Aumenta el volumen de tu dispositivo',
  sound: '¿Puedes escuchar el sonido correctamente?',
  wait_location: 'Verificación de precisión de la ubicación',
  gps: 'La aplicación está intentando obtener tu ubicación',
  gps_error: 'Hay un problema con el GPS de este teléfono',
  gps_quality_bad: 'Precisión de la ubicación mala',
  gps_quality_bad_details: 'Es posible que experimentes problemas con la reproducción automática',
  gps_quality_average: 'Precisión de la ubicación aceptable',
  gps_quality_good: 'Precisión de la ubicación excelente',
  cookies: 'Ya hay un recorrido en curso',
  cookies_action: '¿Te gustaría continuar o empezarlo de nuevo?',
  cookies_delete: 'Cambiar experiencia',
  cookies_maintain: 'Continuar experiencia',
  livorno: '"L" como Livorno',
  unlocking: 'Si necesitas usar la aplicación durante la visita, desbloquéala usando este código',
  unlock: '¿Confirmar desbloqueo?',
  unlock_subtitle: 'Desbloquear la pantalla es solo para administradores',
  areyouready: '¿Listo para empezar?',
  welcome: 'BIENVENIDO',
  map: 'Mapa',
  code: 'Contenido',
  insert_code: 'Introduce la referencia del contenido y toca "Reproducir"',
  try_with: 'Prueba con:',
  faq: [
    {
      q: '¿Problemas de conexión?',
      a: 'Si estás experimentando problemas de conexión, intenta...',
    },
    {
      q: 'Otras preguntas frecuentes',
      a: 'Si estás experimentando problemas de conexión, intenta...',
    },
  ],
  mobile_only: 'Esta aplicación fue diseñada para dispositivos móviles únicamente.',
  screen_locked: 'Pantalla bloqueada',
  swipe_left: 'Desliza hacia la izquierda para desbloquear',
  admin_title: 'Controles de administrador',
  admin_close: 'Cerrar',
  admin_test: 'Prueba de audio',
  admin_reset_soft: 'Cambiar experiencia',
  admin_reset_hard: 'Restablecer aplicación',
  admin_reset_hard_confirm: '¿Quieres restablecer la aplicación?',
  admin_reset_hard_desc:
    'El restablecimiento de la aplicación borrará todas las experiencias guardadas y su contenido. Deberás descargarlas nuevamente.',
  admin_logout: 'Cerrar sesión',
  admin_logout_confirm: '¿Cerrar sesión ahora?',
  admin_logout_desc: 'Deberás escanear el QR o ingresar tus credenciales para volver a iniciar sesión.',
  search_gps: 'Esperando cobertura GPS',
  select_experience: 'Selecciona una experiencia',
  no_experience: 'Parece que no tienes ninguna experiencia disponible.',
  pause: 'Pausa',
  stop: 'Detener',
  stop_all: 'Detener todo',
  stop_video: 'Detener la reproducción de video',
  restart: 'Reanudar',
  beforestart: 'Toca el botón "Comenzar" cuando estés listo para comenzar la experiencia.',
  ispause: 'LA EXPERIENCIA ESTÁ EN PAUSA',
  ispause_restart: 'Haz clic en el botón "Reproducir" para reanudarla.',
  play: 'Reproducir',
  audio_ready: 'agami activo! Presione el botón de abajo para escucharlo.',
  offline_experience: 'Experiencia sin conexión',
  replay_title: 'El contenido está disponible para repetir',
  replay_message: 'Hay contenido disponible que ya has escuchado. ¿Quieres repetirlo?',
  redeem_exp_title: 'Canjear experiencia',
  redeem_exp_result_title: 'Experiencia canjeada',
  redeem_exp_button: 'ACTIVAR',
  go_to_exp_button: 'EMPEZAR',
  check_email_login: 'Revisa tu correo electrónico para confirmar el inicio de sesión.',
  redeemed_until_days: 'Tienes acceso durante los próximos',
  redeemed_until_date: 'Tienes acceso hasta el',
  alreadly_redeemed: 'Parece que ya usaste este código antes. Deberías tener esta experiencia.',
  redeem_ok: 'La experiencia se ha creado correctamente.',

  gps_location_unavailable: 'Servicios de ubicación no disponibles',
  gps_location_unavailable_desc:
    'Los servicios de ubicación están desactivados o no se ha concedido permiso de acceso. Por favor, sigue las instrucciones para verificar la configuración correcta.',
  gps_location_open_phone_settings: 'Abrir configuración del teléfono',
  gps_location_browser_in_use: 'el navegador que estás utilizando',

  gps_location_android_1: 'Ve a "Ubicación"',
  gps_location_android_2: 'Verifica que "Usar ubicación" esté habilitado',
  gps_location_android_3: 'Abre "Permisos de ubicación de la aplicación"',
  gps_location_android_4: 'Desplázate hasta el final en la sección "No permitidas" y verifica si',
  gps_location_android_5: 'está ahí',
  gps_location_android_6:
    'Si ese es el caso, haz clic sobre ella y selecciona "Preguntar siempre" o "Permitir solo mientras se usa la aplicación"',

  gps_location_ios_1: 'Ve a "Privacidad y seguridad" > "Servicios de ubicación"',
  gps_location_ios_2: 'Verifica que "Servicios de ubicación" esté activado',
  gps_location_ios_2_1_chrome:
    'Verifica también que el servicio esté activo para Chrome en la lista siguiente',
  gps_location_ios_2_1_safari:
    'Verifica también que el servicio esté activo para Safari en la lista siguiente',
  gps_location_ios_3: 'Vuelve a la configuración del teléfono',
  gps_location_ios_4: 'Desplázate hacia abajo y busca la configuración de',
  gps_location_ios_5: 'Dentro de la configuración, busca "Ubicación"',
  gps_location_ios_6: 'Selecciona "Preguntar" o "Permitir"',

  gps_location_chrome_1: 'Abre Chrome',
  gps_location_chrome_2: 'Navega hasta',
  gps_location_chrome_3:
    'Abre la configuración del sitio haciendo clic en el icono de los controles deslizantes situado justo a la izquierda de la dirección del sitio web',
  gps_location_chrome_4: 'Selecciona "Permisos"',
  gps_location_chrome_5: 'Verifica que se permita la "Ubicación"',

  gps_location_safari_1: 'Abre Safari',
  gps_location_safari_2: 'Navega hasta',
  gps_location_safari_3:
    'Abre la configuración del sitio haciendo clic en el icono "Aa" situado justo a la izquierda de la dirección del sitio web',
  gps_location_safari_4: 'Selecciona "Configuración del sitio web"',
  gps_location_safari_5:
    'En la sección "Permitir", verifica que la "Ubicación" esté configurada en "Preguntar" o "Permitir"',
  gps_location_safari_6: 'Haz clic en "Listo"',

  gps_location_browser_1: 'Abre tu navegador preferido',
  gps_location_browser_2: 'Navega hasta',
  gps_location_browser_3: 'Abre la configuración del sitio web',
  gps_location_browser_4:
    'Verifica que el permiso de acceso a la ubicación esté configurado en "Preguntar" o "Permitir"',

  go_without_gps: 'Continúa sin ubicación',
  go_without_gps_warning: 'Solo podrás reproducir contenido ingresando los códigos manualmente.',

  read_instructions: 'Lea las instrucciones',

  go_home: 'Home page',

  multiple_agami_active: 'Varios agami activos',

  pwa_install_cta: '¡Disfruta la mejor experiencia!',
  pwa_install_description:
    'Instala Agami Route en tu dispositivo: es rápida, ligera y funciona como una app normal.',
  install: 'Instalar',
  aria_pwa_install_dialog: 'Diálogo de instalación de Agami Route',
  aria_dismiss_pwa_install: 'Cerrar aviso de instalación',

  agami_not_found: 'No se encontró ningún agami con este código.',
  multiple_agami_found: 'Se encontraron varios agami con este código.',

  resume: 'Reanudar',

  qr_scan: 'ESCANEAR QR',
  qr_invalid: 'Código QR inválido',
  qr_frame_instruction: 'Enmarca el código QR dentro de los bordes blancos',

  text_size: 'TAMAÑO DEL TEXTO',
  standard: 'Standard',
  large: 'Grande',
  xlarge: 'Muy grande',

  aria_select_experience: 'Seleccionar experiencia',
  aria_download_experience: 'Descargar experiencia',
  aria_download_experience_in_progress: 'Descargando la experiencia {experience}',
  aria_cancel_download: 'Cancelar descarga',
  aria_refresh_experience: 'Actualizar experiencia',
  aria_next_element: 'Siguiente elemento',
  aria_previous_element: 'Elemento anterior',
  aria_open_language: 'Abrir selección de idioma',
  aria_close_language: 'Cerrar selección de idioma',
  aria_open_font_size: 'Abrir selección de tamaño de texto',
  aria_close_font_size: 'Cerrar selección de tamaño de texto',
  aria_activate_dark_theme: 'Tema actual: día. Activa para cambiar al tema noche',
  aria_activate_light_theme: 'Tema actual: noche. Activa para cambiar al tema día',
  aria_rewind_10_secs: 'Rebobinar 10 segundos',
  aria_fast_forward_10_secs: 'Avanzar 10 segundos',
  aria_open_audio_player: 'Abrir reproductor de audio',
  aria_close_audio_player: 'Cerrar reproductor de audio',
  aria_audio_player_dialog: 'Diálogo de audio activo',
  aria_audio_playback_progress: 'Progreso de reproducción de audio',
  aria_audio_elapsed_time: 'Tiempo transcurrido {elapsed}, de una duración total de {total}',
  aria_login_with_email_only: 'Cambiar al modo de acceso sólo por correo electrónico',
  aria_login_with_email_password: 'Cambiar al modo de acceso con correo electrónico y contraseña',
  aria_offline_mode: 'Acceder al modo sin conexión',
  aria_send_otp_email: 'Enviar correo electrónico de acceso',
  aria_show_password: 'Mostrar contraseña',
  aria_hide_password: 'Ocultar contraseña',
  aria_open_qr_scanner: 'Abrir escáner QR',
  aria_close_qr_scanner: 'Cerrar escáner QR',
  aria_qr_panel: 'Panel de escáner QR',
  aria_qr_scanner_preview: 'Vista previa de la cámara del escáner QR',
  aria_manual_playback_code_input: 'Código de reproducción manual',
  aria_start_manual_content: 'Iniciar contenido manual',
  aria_redeem_experience: 'Canjear experiencia',
  aria_experience_redeem_code_input: 'Código de canje de experiencia',
  aria_loading: 'Cargando',
  aria_go_to_experience: 'Ir a la experiencia',
  aria_manual_playback_code_dialog: 'Ventana de entrada de código de reproducción manual',
  aria_replay_content_dialog: 'Ventana para volver a escuchar el contenido',
  aria_open_video_player: 'Abrir reproductor de video',
  aria_close_video_player: 'Cerrar reproductor de video',
  aria_active_video_dialog: 'Ventana de video activo',
  aria_open_controls_menu: 'Abrir menú de controles',
  aria_close_controls_menu: 'Cerrar menú de controles',
  aria_onboarding_step_sentence: 'Paso de incorporación número {current} de {total}',

  experience_redeemed_successfully: 'Experiencia canjeada con éxito',
  something_went_wrong: 'Algo salió mal',

  language: 'Idioma',

  credits: 'Créditos',
  noCredits: 'Todavía no hay créditos para esta experiencia',

  download_experience_title: 'Descargar experiencia',
  download_experience_preparing: 'Preparando la descarga...',
  download_experience_config: 'Descargando configuración...',
  download_experience_audio: 'Descargando audio...',
  download_experience_video: 'Descargando video...',
  download_experience_credits: 'Descargando créditos...',
  download_experience_maps: 'Descargando mapas...',

  download_experience_error: 'Error al descargar la experiencia',
  download_experience_done: '¡Experiencia descargada y lista para usar sin conexión!',
  download_experierience_config_error:
    'La experiencia guardada tiene problemas de configuración. Conéctate y descárgala de nuevo',
  download_experience_not_allowed: 'El modo sin conexión no está permitido para esta experiencia',

  get_experience_data_error: 'Error al obtener los datos de la experiencia',
  get_experience_config_error: 'Error al obtener la configuración de la experiencia',

  session_expired_title: 'Sesión expirada',
  session_expired_message:
    'Tu sesión ha expirado y se cerró tu cuenta. Inicia sesión de nuevo para continuar.',
  session_expired_action: 'Iniciar sesión de nuevo',

  wrong_credentials: 'Credenciales incorrectas',
  invalid_email: 'Correo electrónico no válido',
  reset_password_instructions: 'Las instrucciones han sido enviadas. Revisa tu correo electrónico',

  footer_onboarding_prefix: 'una experiencia ',
  footer_onboarding_link: 'agami',
  footer_onboarding_suffix: '',
  footer_experience_prefix: 'powered by ',
  footer_experience_link: 'Mezzo Forte',
};

export default es;
